import type { AppRouteRecordRaw } from '/@/router/types';
import { t } from '/@/hooks/web/useI18n';
import { REDIRECT_NAME, LAYOUT, EXCEPTION_COMPONENT, PAGE_NOT_FOUND_NAME } from '/@/router/constant';

// 404 on a page
export const PAGE_NOT_FOUND_ROUTE: AppRouteRecordRaw = {
  path: '/:path(.*)*',
  name: PAGE_NOT_FOUND_NAME,
  component: LAYOUT,
  meta: {
    title: 'ErrorPage',
    hideBreadcrumb: true,
    hideMenu: true,
  },
  children: [
    {
      path: '/:path(.*)*',
      name: PAGE_NOT_FOUND_NAME,
      component: EXCEPTION_COMPONENT,
      meta: {
        title: 'ErrorPage',
        hideBreadcrumb: true,
        hideMenu: true,
      },
    },
  ],
};

export const REDIRECT_ROUTE: AppRouteRecordRaw = {
  path: '/redirect',
  component: LAYOUT,
  name: 'RedirectTo',
  meta: {
    title: REDIRECT_NAME,
    hideBreadcrumb: true,
    hideMenu: true,
  },
  children: [
    {
      path: '/redirect/:path(.*)',
      name: REDIRECT_NAME,
      component: () => import('/@/views/sys/redirect/index.vue'),
      meta: {
        title: REDIRECT_NAME,
        hideBreadcrumb: true,
      },
    },
  ],
};

export const ERROR_LOG_ROUTE: AppRouteRecordRaw = {
  path: '/error-log',
  name: 'ErrorLog',
  component: LAYOUT,
  redirect: '/error-log/list',
  meta: {
    title: 'ErrorLog',
    hideBreadcrumb: true,
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'list',
      name: 'ErrorLogList',
      component: () => import('/@/views/sys/error-log/index.vue'),
      meta: {
        title: t('routes.basic.errorLogList'),
        hideBreadcrumb: true,
        currentActiveMenu: '/error-log',
      },
    },
  ],
};
export const PAGE_REGISTER_ROUTE: AppRouteRecordRaw = {
  path: '/register',
  name: 'Register',
  component: () => import('/@/views/sys/register/index.vue'),
  meta: {
    title: '注册',
    ignoreAuth: true,
  },
};

export const PAGE_EXTERNAL_ROUTE: AppRouteRecordRaw = {
  path: '/external',
  name: 'External',
  component: () => import('/@/views/sys/external/index.vue'),
  meta: {
    title: '',
    ignoreAuth: true,
  },
};

export const PAGE_FLOW_ROUTE: AppRouteRecordRaw = {
  path: '/wflow',
  name: 'Wflow',
  component: () => import('/@/views/flowable/definition/add.vue'),
  meta: {
    title: '',
    ignoreAuth: true,
  },
};

export const PAGE_COOPERATE_ROUTE: AppRouteRecordRaw = {
  path: '/cooperate',
  name: 'cooperate',
  component: () => import('/@/views/organization/cooperate.vue'),
  meta: {
    title: '合作伙伴邀请',
    ignoreAuth: true,
  },
};

export const PAGE_HTML_TEMPLATE_ROUTE: AppRouteRecordRaw = {
  path: '/htmlTemplate',
  name: 'htmlTemplate',
  meta: {
    title: 'ErrorLog',
    hideBreadcrumb: true,
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'questionDetail',
      name: 'questionDetail',
      component: () => import('/@/views/htmlTemplate/questionDetail.vue'),
      meta: {
        title: '问卷详情',
        ignoreAuth: true,
      },
    },
    {
      path: 'formDetail',
      name: 'formDetail',
      component: () => import('/@/views/htmlTemplate/formDetail.vue'),
      meta: {
        title: '表单详情',
        ignoreAuth: true,
      },
    },
  ],
};

export const PAGE_CONTENT_OPERATION_DETAIL_ROUTE: AppRouteRecordRaw = {
  path: '/system/contentOperation/detail/:id',
  name: 'ContentOperationDetail',
  component: LAYOUT,
  meta: {
    title: '内容详情',
    hideBreadcrumb: true,
    hideMenu: true,
  },
  children: [
    {
      path: '',
      name: 'ContentOperationDetailPage',
      component: () => import('/@/views/system/contentOperation/detail.vue'),
      meta: {
        title: '内容详情',
        hideBreadcrumb: true,
        hideMenu: true,
        currentActiveMenu: '/system/contentOperation',
      },
    },
  ],
};

